module.exports = __webpack_public_path__ + "static/media/CommunityDetails2Screen_elSkilledNursingPrivateFeeUserPic_1718355198.60f6999b.jpg";